import React, { useState } from 'react';

const SquareTable = () => {
  const [startNumber, setStartNumber] = useState(0);
  const [endNumber, setEndNumber] = useState(10);
  const [squareTable, setSquareTable] = useState([]);

  const calculateSquareTable = () => {
    if (startNumber < 0 || endNumber > 999 || startNumber > endNumber) {
      alert("Please enter a valid range (0 to 999) and ensure start is less than or equal to end.");
      return;
    }

    const table = [];
    for (let i = startNumber; i <= endNumber; i++) {
      table.push({ number: i, square: i * i });
    }
    setSquareTable(table);
  };

  return (
    <div>
      <h2>Square Table Generator</h2>
      <label htmlFor="startNumber">Start Number (0-999): </label>
      <input
        type="number"
        id="startNumber"
        min="0"
        max="999"
        value={startNumber}
        onChange={(e) => setStartNumber(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="endNumber">End Number (0-999): </label>
      <input
        type="number"
        id="endNumber"
        min="0"
        max="999"
        value={endNumber}
        onChange={(e) => setEndNumber(parseInt(e.target.value))}
      />
      <br />
      <button onClick={calculateSquareTable}>Generate Table</button>

      {squareTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Number</th>
              <th>Square</th>
            </tr>
          </thead>
          <tbody>
            {squareTable.map((row, index) => (
              <tr key={index}>
                <td>{row.number}</td>
                <td>{row.square}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SquareTable;
